import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { GetNextStatementResponse } from './bookkeeping.types';

function useNextStatement(corporationId: number) {
  const url = `bookkeeping/${corporationId}/next-statement`;

  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data: GetNextStatementResponse;
    error: Error;
    mutate: KeyedMutator<GetNextStatementResponse>;
    isLoading: boolean;
  } = useSWR(
    corporationId ? url : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading: isLoading ?? false,
  };
}

export { useNextStatement };
